import React from 'react';

export default function Story() {
  return (
    <section id="story" className="story">
      <div className="story-inner">
        <h2 className="story-title">המסע שלנו אל לב הקפה של האלפים</h2>
        <div className="story-body">
          <p>
            הכל התחיל בטיול משפחתי של שלושה דורות לאלפים. סבא וסבתא,
            ההורים והילדים — כולנו יחד בין פסגות מושלגות וכפרים ציוריים. אחרי
            בוקר ארוך של טיולים חיפשנו הפסקת קפה קצרה, ונכנסנו למה שנראה כמו
            חנות מעוצבת ברחוב הראשי.
          </p>
          <p>
            בפנים גילינו עולם שלם: חלל מודרני עם מוצרי לייף סטייל תמטיים —
            ביגוד, כלי בית, אקססוריז — ולצד כל זה, פינת קפה אמיתית. השלט אמר
            Tchibo. הריח של פולים טריים שנקלו במקום מילא את החלל, והזמנו סבב
            כוסות למבוגרים. הלגימה הראשונה עשתה את זה — עומק שוקולדי, חמיצות
            עדינה ונעימה, וגימור חלק שנשאר על החך. סבתא חייכה, ואנחנו פשוט
            הסתכלנו אחד על השנייה וידענו: זה הקפה שחיפשנו כל החיים.
          </p>
          <p>
            באותו רגע הבנו שחוויית הקפה הזו — האותנטית, האיכותית, האלפינית — חסרה
            לגמרי בישראל. החלטנו להביא אותה הביתה. כך נולד CoffeeIL: גשר ישיר בין
            מסורת הקלייה של Tchibo לבין כוס הבוקר שלכם.
          </p>
        </div>
      </div>
    </section>
  );
}
